import { createContext } from 'react';

export const IntelligenceContext = createContext();
